import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ } from "../mock";

const FaqSection = () => {
  return (
    <section id="faq" className="scroll-mt-20 py-12 md:py-20">
      <div className="w-[90%] max-w-[820px] mx-auto">
        <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl md:text-5xl text-center mb-12">
          Questions, <span className="text-gold-gradient">answered</span>
        </h2>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-white/10 rounded-2xl px-6 bg-card/50 data-[state=open]:border-primary/30"
            >
              <AccordionTrigger className="text-left font-display font-bold uppercase tracking-tight text-base md:text-lg text-white hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed font-medium text-base pb-5">
                {Array.isArray(item.a)
                  ? item.a.map((para, j) => (
                      <p
                        key={j}
                        className={`mb-3 last:mb-0 ${para.strong ? "text-white font-semibold" : ""}`}
                      >
                        {para.t}
                      </p>
                    ))
                  : item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
